export function loadScript(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = function () {
      resolve();
    };
    script.onerror = function () {
      reject('Failed to load script ' + src);
    };
    document.head.appendChild(script);
  });
}
